import PropTypes from "prop-types"
import { connect } from "react-redux"

import ImageOptions from "./choice/image-options"
import InitialOptions from "./choice/initial-options"
import SelectOptions from "./choice/select-options"
import StylecodeSwitcher from "./choice/stylecode-switcher"
import TextOptions from "./choice/text-options"

const InternalChoiceOptions = ({ data, options, selectedValues }) => {
  switch (data.ui_type) {
    case "dropdown":
      /* example product - JWLP0567-A */
      /* example product - JWLN0473-1-A/2/3/4/5/6 */

      return (
        <>
          {Object.keys(options).map((pref, i) => {
            return (
              <SelectOptions
                displayLabel={data.options_display_labels[pref]}
                key={i}
                options={options[pref]}
                pref={pref}
              />
            )
          })}
        </>
      )
    case "image":
      /* example product - JWLM0069-7 */
      return <ImageOptions data={data} />
    case "initials":
      /* example product - JLUX56-P2 */
      return (
        <InitialOptions
          data={data}
          options={options}
          selectedValues={selectedValues}
        />
      )
    case "stylecode":
      /* example product - JWLN0473-4, JWLM0069-7 */
      return Object.keys(options).map((pref) => (
        <StylecodeSwitcher
          data={data}
          displayLabel={
            Object.keys(options).length > 1 && data.options_display_labels[pref]
          }
          key={`switcher-${pref}`}
          options={options[pref]}
          pref={pref}
        />
      ))
    default:
      /* example product - JWL0450-NUMBER*/
      /* example product (Hebrew) - JWLN0766-TEST-1 */

      return (
        <TextOptions
          data={data}
          options={options}
          selectedValues={selectedValues}
        />
      )
  }
}

InternalChoiceOptions.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  selectedValues: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => {
  const data = state.wizard.data[ownProps.pref]
  let selectedValues = {}
  let i = 1
  while (state.choices["o" + i]) {
    selectedValues["o" + i] = state.choices["o" + i].value || ""
    i += 1
  }

  let options = {}
  if (data && !data.disabled) {
    data.options.forEach((opt) => {
      if (options[opt.pref]) {
        options[opt.pref].push(opt)
      } else {
        options[opt.pref] = [opt]
      }
    })
  }

  return {
    data,
    options,
    selectedValues,
  }
}

const mapDispatchToProps = () => {
  return {}
}

const ChoiceOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalChoiceOptions)

export default ChoiceOptions
